import * as React from 'react';

import ButtonLink from './ButtonLink';
import { InlineTextLink } from './InlineTextLink';

const Link = {
  button: ButtonLink,
  inline: InlineTextLink
};

export default Link;

// stylguidist requires a react component to be exported to generate a place in the styleguide
export const Links: React.FC = () => <></>;
